import React, { createRef } from 'react';
import Vimeo from '@vimeo/player';

export default class VimeoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.vimeoRef = createRef();
  }
  componentDidMount() {
    const ifreume = this.vimeoRef.current;
    const player = new Vimeo(ifreume);

    player.on('ended', () => {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    });
  }
  render() {
    return (
      <div className={'vimeo-player'}>
        <iframe ref={this.vimeoRef} title="Vimeo Video" src={`https://player.vimeo.com/video/${this.props.vimeoId}`} frameBorder={0} allowFullScreen={true} />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/elements/VimeoPlayer.js